import { MapPin, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { VKMessagesIcon, VKCommunityIcon, WhatsAppIcon, TelegramIcon } from "./SocialIcons";
import logoWhite from "@/assets/logo-white.png";
import { trackSocialClick } from "@/lib/analytics";

const Footer = () => {
  const socialLinks = [
    {
      name: "VK Сообщения", 
      url: "https://vk.com/im?sel=-214021218",
      icon: <VKMessagesIcon className="text-blue-500" />,
    },
    {
      name: "VK Сообщество",
      url: "https://vk.com/w_wagner_art", 
      icon: <VKCommunityIcon className="text-blue-600" />,
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/79507818785",
      icon: <WhatsAppIcon className="text-green-500" />,
    },
    {
      name: "Telegram", 
      url: "https://t.me/FallenSonS",
      icon: <TelegramIcon className="text-blue-400" />,
    },
  ];

  return (
    <footer className="bg-card border-t border-border/50 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Logo Section */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <img 
              src={logoWhite} 
              alt="Логотип W-Wagner.art - художественная мастерская Валерии Вагнер в Омске" 
              className="h-16 w-auto drop-shadow-lg filter brightness-125"
            />
          </div>
          <p className="text-sm text-muted-foreground max-w-md mx-auto">
            Профессиональная художественная мастерская в Омске. Создаём уникальные произведения искусства с душой.
          </p>
        </div>

        <Separator className="mb-8" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Контактная информация */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-primary mb-4">
              Художественная мастерская
            </h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-muted-foreground">
                <MapPin className="w-4 h-4 text-primary" />
                <span className="text-sm">Омск, ул. 21 Амурская 37</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <Phone className="w-4 h-4 text-primary" />
                <div className="text-sm">
                  <a href="tel:+79088005799" className="hover:text-primary transition-colors block">
                    8-908-800-57-99
                  </a>
                  <a href="tel:+79507818785" className="hover:text-primary transition-colors block">
                    8-950-781-87-85
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <Mail className="w-4 h-4 text-primary" />
                <a href="mailto:info@w-wagner.art" className="text-sm hover:text-primary transition-colors">
                  info@w-wagner.art
                </a>
              </div>
            </div>
          </div>

          {/* О художнике */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-primary mb-4">
              О художнике
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Валерия Вагнер — профессиональный художник, работающий с различными материалами, 
              от классического холста до уличной живописи. Создаю уникальные произведения 
              искусства, которые вызывают эмоции и вдохновляют.
            </p>
          </div>

          {/* Социальные сети */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-primary mb-4">
              Социальные сети
            </h3>
            <div className="flex gap-3 justify-center md:justify-start flex-wrap">
              {socialLinks.map((social) => (
                <Button
                  key={social.name}
                  variant="outline"
                  size="sm"
                  asChild
                  className="w-12 h-12 p-0 hover:border-primary/50"
                >
                  <a 
                    href={social.url} 
                    target="_blank"
                    onClick={() => trackSocialClick(social.name, 'footer')}
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                    title={social.name}
                  >
                    <span className="text-primary">{social.icon}</span>
                  </a>
                </Button>
              ))}
            </div>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-sm text-muted-foreground">
              © 2024 Валерия Вагнер. Все права защищены.
            </p>
          </div>
          <div className="text-center md:text-right">
            <p className="text-xs text-muted-foreground">
              Художественная мастерская • Омск
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;